export default __webpack_public_path__ + "static/media/crown.dbe416be.png";